(function () {
  var headers = document.querySelectorAll('.oddit-header');
  if (!headers.length) return;

  headers.forEach(function (header) {
    initHeader(header);
  });

  function initHeader(header) {
    var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var megaPanels = header.querySelectorAll('[data-mega-menu-panel]');
    var mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
    var mobileMenu = header.querySelector('.oddit-header__mobile-menu');
    var overlay = header.querySelector('[data-header-overlay]');

    var megaCloseTimer = null;
    var activeTrigger = null;
    var activeMegaPanel = null;

    function isHoverPointer(e) {
      return e.pointerType === 'mouse' || e.pointerType === 'pen';
    }

    function getPanelForLabel(label) {
      if (!label) return null;
      for (var i = 0; i < megaPanels.length; i++) {
        if (megaPanels[i].getAttribute('data-mega-menu-label') === label) {
          return megaPanels[i];
        }
      }
      return null;
    }

    function closeAllMegaPanels() {
      for (var i = 0; i < megaPanels.length; i++) {
        megaPanels[i].classList.remove('is-open');
        megaPanels[i].setAttribute('aria-hidden', 'true');
      }
      activeMegaPanel = null;
    }

    function openMegaMenu(label) {
      var panel = getPanelForLabel(label);
      if (!panel) return;
      closeAllMegaPanels();
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      activeMegaPanel = panel;
      if (overlay) overlay.classList.add('is-visible');
    }

    function closeMegaMenu() {
      closeAllMegaPanels();
      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      activeTrigger = null;
      var mobileOpen = mobileMenu && mobileMenu.classList.contains('is-open');
      if (overlay && !mobileOpen) {
        overlay.classList.remove('is-visible');
      }
    }

    function openMegaMenuFor(trigger) {
      if (megaCloseTimer) {
        clearTimeout(megaCloseTimer);
        megaCloseTimer = null;
      }
      var label = trigger.getAttribute('data-mega-menu-label') || '';
      if (!getPanelForLabel(label)) return;
      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
      openMegaMenu(label);
    }

    function scheduleCloseMegaMenu() {
      if (megaCloseTimer) clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(function () {
        closeMegaMenu();
        megaCloseTimer = null;
      }, 180);
    }

    /* -------------------- Mega menu trigger bindings -------------------- */
    megaTriggers.forEach(function (trigger) {
      var wrapper = trigger.closest('.oddit-header__link-wrapper') || trigger.parentElement;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeMegaMenu();
        } else {
          openMegaMenuFor(trigger);
        }
      });

      if (wrapper) {
        wrapper.addEventListener('pointerenter', function (e) {
          if (!isHoverPointer(e)) return;
          openMegaMenuFor(trigger);
        });
        wrapper.addEventListener('pointerleave', function (e) {
          if (!isHoverPointer(e)) return;
          scheduleCloseMegaMenu();
        });
      }
    });

    megaPanels.forEach(function (panel) {
      panel.addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        if (megaCloseTimer) {
          clearTimeout(megaCloseTimer);
          megaCloseTimer = null;
        }
      });
      panel.addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        scheduleCloseMegaMenu();
      });
    });

    /* -------------------- Mobile menu -------------------- */
    function openMobileMenu() {
      if (!mobileMenu) return;
      // Start the menu just below the header (announcement bar + header stay visible)
      // and let it fill the rest of the viewport.
      var headerBottom = header.getBoundingClientRect().bottom;
      mobileMenu.style.setProperty('--oddit-mobile-menu-top', Math.max(0, headerBottom) + 'px');
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (mobileToggle) {
        mobileToggle.setAttribute('aria-expanded', 'true');
        mobileToggle.setAttribute('aria-label', 'Close menu');
      }
      if (overlay) overlay.classList.add('is-visible');
      document.body.classList.add('oddit-header-menu-open');
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (mobileToggle) {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileToggle.setAttribute('aria-label', 'Open menu');
      }
      var megaOpen = activeMegaPanel && activeMegaPanel.classList.contains('is-open');
      if (overlay && !megaOpen) {
        overlay.classList.remove('is-visible');
      }
      document.body.classList.remove('oddit-header-menu-open');
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = mobileMenu && mobileMenu.classList.contains('is-open');
        if (isOpen) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });
    }

    /* -------------------- Overlay click -------------------- */
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeMegaMenu();
        closeMobileMenu();
      });
    }

    /* -------------------- Escape closes everything -------------------- */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        closeMegaMenu();
        closeMobileMenu();
      }
    });

    /* -------------------- Cart drawer toggle -------------------- */
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    for (var i = 0; i < cartToggles.length; i++) {
      cartToggles[i].addEventListener('click', function () {
        if (window.OdditCartDrawer) {
          window.OdditCartDrawer.open();
        }
      });
    }
  }

  /* -------------------- Live cart count badge -------------------- */
  document.addEventListener('cart:updated', function (e) {
    if (!e || !e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });
})();
